import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
import { AdServerQtvSimilarTitleFragmentDoc } from './AdServerQtvSimilarTitle.fragment';
export type AdServerQtvCreativeFragment = {
	__typename: 'CreativeQTVContent';
	offer: {
		__typename: 'Offer';
		id: string;
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		standardWebURL?: string | null;
		package: {
			__typename: 'Package';
			id: string;
			packageId: number;
			clearName: string;
			shortName: string;
			icon: string;
			iconWide: string;
			maskReferrer?: boolean | null;
			technicalName: string;
			planOffers: Array<{ __typename: 'PackagePlanOffer'; retailPrice?: string | null }>;
		};
	};
	similarTitles: Array<{
		__typename: 'AdSimilarTitle';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		similarityScore: number;
		content: {
			__typename: 'AdSimilarTitleContent';
			title: string;
			posterUrl?: string | null;
			fullPath: string;
			scoring?: { __typename: 'Scoring'; imdbScore?: number | null } | null;
		};
		offers: Array<{
			__typename: 'Offer';
			id: string;
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			standardWebURL?: string | null;
			package: {
				__typename: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				icon: string;
				iconWide: string;
				maskReferrer?: boolean | null;
				technicalName: string;
			};
		}>;
	}>;
};

export const AdServerQtvCreativeFragmentDoc = gql`
	fragment AdServerQTVCreative on CreativeQTVContent {
		offer {
			...TitleOfferLight
			package {
				planOffers(country: $country, platform: WEB) {
					retailPrice(language: $language)
					__typename
				}
				__typename
			}
			__typename
		}
		similarTitles {
			...AdServerQtvSimilarTitle
		}
		__typename
	}
	${TitleOfferLightFragmentDoc}
	${AdServerQtvSimilarTitleFragmentDoc}
`;
